/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1TransportTypeModel } from '../../entities/v1/TransportTypeModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1TransportTypeModelSchema = z.object({
  drivee_id: z.number().int(),
  id: z.string(),
  name: z.string(),
}) as unknown as ToZod<V1TransportTypeModel>